import React, { JSX } from 'react';
import { ServiceId } from '@/@types/application';
import { LOGO, SERVICES } from '../constants';
import Style from './Status.module.scss';

interface Props {
  serviceId: ServiceId;
  serviceStatusCode: string;
  serviceStatusName: string;
  serviceStatusMessage: string;
  location: string;
}

const Status: React.FC<Props> = ({
  serviceId,
  serviceStatusCode,
  serviceStatusName,
  serviceStatusMessage,
  location,
}): JSX.Element => {
  return (
    <div className={Style.panel} data-status={serviceStatusCode} data-location={location}>
      <div className={Style.top}>
        <span className={Style.icon}>
          <img src={LOGO[serviceId]} className={Style.image} alt="" />
        </span>
        <div className={Style.text}>
          <div className={Style.service}>{SERVICES[serviceId]}</div>
          <span className={Style.label}>{serviceStatusName}</span>
        </div>
      </div>
      <div className={Style.bottom}>
        <div className={Style.message}>{serviceStatusMessage}</div>
      </div>
    </div>
  );
};

export default Status;
